(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-offer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(cents, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: currency }).format(cents / 100);
      } catch (error) {
        return (cents / 100).toFixed(2) + ' ' + currency;
      }
    }

    function annotate(percent, code, currency, template) {
      document.querySelectorAll('[data-lp-priced]').forEach(function (price) {
        var cents = parseInt(price.dataset.cents, 10);
        var holder = price.parentElement;
        if (!cents || !holder || holder.querySelector('.lp-card__codeprice')) return;
        var line = document.createElement('span');
        line.className = 'lp-card__codeprice';
        line.textContent = template.replace('{code}', code).replace('{price}', money(Math.round(cents * (100 - percent) / 100), currency));
        holder.appendChild(line);
      });
    }

    function init(bar) {
      if (bar.dataset.lpReady) return;
      bar.dataset.lpReady = '1';
      var code = bar.dataset.code;
      var percent = parseInt(bar.dataset.percent, 10) || 0;
      var ends = parseInt(bar.dataset.ends, 10) || 0;
      var expired = bar.classList.contains('lp-offer--expired');

      var copy = bar.querySelector('[data-lp-copy]');
      if (copy) {
        copy.addEventListener('click', function () {
          var state = copy.querySelector('[data-lp-copy-state]');
          var original = state ? state.textContent : '';
          var done = function () {
            if (!state) return;
            state.textContent = copy.dataset.copied;
            setTimeout(function () { state.textContent = original; }, 2000);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(copy.dataset.lpCopy).then(done, done);
          } else {
            done();
          }
        });
      }

      var timer = bar.querySelector('[data-lp-timer]');
      if (timer && ends) {
        var tick = function () {
          var left = ends - Math.floor(Date.now() / 1000);
          if (left <= 0) {
            bar.hidden = true;
            return false;
          }
          var days = Math.floor(left / 86400);
          var hours = Math.floor((left % 86400) / 3600);
          var minutes = Math.floor((left % 3600) / 60);
          timer.textContent = bar.dataset.timerLabel + ' ' + (days ? days + ' j ' : '') + String(hours).padStart(2, '0') + ' h ' + String(minutes).padStart(2, '0') + ' min';
          return true;
        };
        if (tick()) setInterval(tick, 30000);
      }

      if (!expired && code && bar.dataset.autoApply === 'true') {
        var key = 'lp-discount-' + code;
        var already = false;
        try { already = !!sessionStorage.getItem(key); } catch (error) { already = false; }
        if (!already) {
          try { sessionStorage.setItem(key, '1'); } catch (error) { /* storage blocked */ }
          fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' });
        }
      }

      if (!expired && percent > 0 && code) {
        annotate(percent, code, bar.dataset.currency, bar.dataset.codePriceLabel);
      }
    }

    function initAll(scope) {
      scope.querySelectorAll('[data-lp-offer]').forEach(init);
    }

    initAll(document);
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
